import React, {useState, useEffect} from 'react'
import {Redirect} from 'react-router-dom'
import gql from 'graphql-tag'
import {Modal} from 'antd'
import Query from 'components/shared/Query'
import Heading from 'components/shared/Heading'
import EstateInformationForm from './EstateInformationForm'
import './index.scss'

const brokerFragment = gql`
  fragment Broker on Broker {
    id
    name
    email
    customer {
      id
      name
    }
  }
`

const EstateInfoViewerQuery = gql`
  query EstateInfoViewerQuery($id: ID!, $fetchWebOrder: Boolean!) {
    viewer {
      id
      name
      broker {
        ...Broker
        linkedAccounts {
          ...Broker
        }
      }
      canOrderForOthers
    }
    webOrder(id: $id) @include(if: $fetchWebOrder) {
      id
      broker {
        id
        name
        email
      }
      possibleContactPersons {
        ...Broker
      }
    }
  }
  ${brokerFragment}
`

const EstateInformation = ({estate, estateReducer, submitWebOrder, goToPreviousStep, match}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [goToWebOrderId, setGoToWebOrderId] = useState()

  useEffect(() => {
    if (isSubmitting) {
      submitWebOrder().then((webOrder) => {
        setGoToWebOrderId(webOrder.id)
      }).catch(() => {
        setIsSubmitting(false)
        Modal.error({
          title: 'Feil ved innsending av ordre',
          content: (
            <div>
              <p>Beklager! En feil oppstod.</p>
              <p>Se over at all informasjon er korrekt fylt ut, eller kontakt kundeservice på 21 08 05 00.</p>
            </div>
          ),
        })
      })
    }
    // submitWebOrder is different on each render so having it in the list below
    // resulted in duplicate web orders being created.
  }, [isSubmitting]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleSubmit = (data) => {
    estateReducer({type: 'setInformation', information: data})
    setIsSubmitting(true)
  }

  if (goToWebOrderId) {
    return (
      <Redirect to={`/bestilling/${goToWebOrderId}`} />
    )
  }

  const id = match.params.webOrderId || ''

  return (
    <Query
      inlineError
      inlineLoading
      query={EstateInfoViewerQuery}
      variables={{id, fetchWebOrder: !!id}}
    >
      {({getData}) => (
        <div className="new-order estate-information">
          <Heading level={2}>Objektinformasjon</Heading>

          <EstateInformationForm
            estate={estate}
            viewer={getData('viewer')}
            contactPerson={getData('webOrder.broker')}
            possibleContactPersons={getData('webOrder.possibleContactPersons', [])}
            isSubmitting={isSubmitting}
            handleSubmit={handleSubmit}
            goToPreviousStep={goToPreviousStep}
          />
        </div>
      )}
    </Query>
  )
}

export default EstateInformation
